// BEGIN motorbikeBackpackGalleryRestore20260716
;(function motorbikeBackpackGalleryRestore20260716() {
  var config = {
  "handle": "seibertron-falcon-water-repellent-hiking-camping-backpack-compact-pack-summit-bag",
  "entries": [
    {
      "id": "33449078554814",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-falcon-backpack-khaki-main-20260715.jpg?v=1784085217",
      "alt": "seibertron-gallery:falcon-backpack-20260715 | product:falcon-backpack | color:Khaki | slot:1 | Seibertron Falcon backpack khaki 37L motorcycle riding backpack main scene"
    },
    {
      "id": "33449078587582",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-falcon-backpack-black-main-20260715.jpg?v=1784085217",
      "alt": "seibertron-gallery:falcon-backpack-20260715 | product:falcon-backpack | color:Black | slot:2 | Seibertron Falcon backpack black 37L motorcycle riding backpack scene"
    },
    {
      "id": "33449078620350",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-falcon-backpack-black-back-20260715.jpg?v=1784085217",
      "alt": "seibertron-gallery:falcon-backpack-20260715 | product:falcon-backpack | color:Black | slot:3 | Seibertron Falcon backpack black 37L backpack rear wearing scene"
    },
    {
      "id": "33449078653118",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-falcon-backpack-khaki-side-20260715.jpg?v=1784085217",
      "alt": "seibertron-gallery:falcon-backpack-20260715 | product:falcon-backpack | color:Khaki | slot:4 | Seibertron Falcon backpack khaki 37L backpack side riding scene"
    },
    {
      "id": "33449078685886",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-falcon-backpack-khaki-back-20260715.jpg?v=1784085217",
      "alt": "seibertron-gallery:falcon-backpack-20260715 | product:falcon-backpack | color:Khaki | slot:5 | Seibertron Falcon backpack khaki 37L backpack rear riding scene"
    },
    {
      "id": "24117278113982",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/products/Seibertron-Falcon-Water-Repellent-Hiking-Camping-Backpack-Compact-Pack-Summit-Bag-Seibertron-24117278113982.jpg?v=1769483329",
      "alt": "Seibertron Falcon Water Repellent Hiking Camping Backpack Compact Pack Summit Bag"
    },
    {
      "id": "31065492226238",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Falcon-Water-Repellent-Hiking-Camping-Backpack-Compact-Pack-Summit-Bag-Seibertron-31065492226238.png?v=1769483329",
      "alt": "Seibertron Military Tactical Bag MOLLE Backpack - Seibertron"
    },
    {
      "id": "28746483826878",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Falcon-Water-Repellent-Hiking-Camping-Backpack-Compact-Pack-Summit-Bag-Seibertron-28746483826878.jpg?v=1769483329",
      "alt": "Lightweight and compact camping backpack perfect for long hikes and campsites."
    },
    {
      "id": "28746483630270",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Falcon-Water-Repellent-Hiking-Camping-Backpack-Compact-Pack-Summit-Bag-Seibertron-28746483630270.jpg?v=1769483329",
      "alt": "Durable summit backpack with waterproof design for high-altitude adventures."
    },
    {
      "id": "24008373272766",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/products/Seibertron-Falcon-Water-Repellent-Hiking-Camping-Backpack-Compact-Pack-Summit-Bag-Seibertron-24008373272766.jpg?v=1769483329",
      "alt": "Compact foldable hiking backpack for easy packing and traveling."
    },
    {
      "id": "28746483302590",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Falcon-Water-Repellent-Hiking-Camping-Backpack-Compact-Pack-Summit-Bag-Seibertron-28746483302590.jpg?v=1769483329",
      "alt": "Multi-pocket storage hiking backpack for organized outdoor gear."
    },
    {
      "id": "28746483728574",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Falcon-Water-Repellent-Hiking-Camping-Backpack-Compact-Pack-Summit-Bag-Seibertron-28746483728574.jpg?v=1769483329",
      "alt": "Water-resistant camping backpack designed for trekking and climbing."
    },
    {
      "id": "28746484613310",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Falcon-Water-Repellent-Hiking-Camping-Backpack-Compact-Pack-Summit-Bag-Seibertron-28746484613310.jpg?v=1769483329",
      "alt": "Adventure gear backpack designed for summit climbs and day hikes."
    },
    {
      "id": "28746483007678",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Falcon-Water-Repellent-Hiking-Camping-Backpack-Compact-Pack-Summit-Bag-Seibertron-28746483007678.jpg?v=1769483329",
      "alt": "Lightweight backpack perfect for camping and travel excursions."
    },
    {
      "id": "28746483171518",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Falcon-Water-Repellent-Hiking-Camping-Backpack-Compact-Pack-Summit-Bag-Seibertron-28746483171518.jpg?v=1769483329",
      "alt": "Outdoor hiking backpack with adjustable straps for maximum comfort."
    },
    {
      "id": "24008373207230",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/products/Seibertron-Falcon-Water-Repellent-Hiking-Camping-Backpack-Compact-Pack-Summit-Bag-Seibertron-24008373207230.jpg?v=1769483329",
      "alt": "Waterproof backpack ideal for hiking during rainy weather conditions."
    },
    {
      "id": "31065492095166",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Falcon-Water-Repellent-Hiking-Camping-Backpack-Compact-Pack-Summit-Bag-Seibertron-31065492095166.png?v=1769483329",
      "alt": "military bag"
    },
    {
      "id": "24127799820478",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/products/Seibertron-Falcon-Water-Repellent-Hiking-Camping-Backpack-Compact-Pack-Summit-Bag-Seibertron-24127799820478.jpg?v=1769483329",
      "alt": "Durable trekking backpack designed for rugged outdoor activities."
    },
    {
      "id": "28746483663038",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Falcon-Water-Repellent-Hiking-Camping-Backpack-Compact-Pack-Summit-Bag-Seibertron-28746483663038.jpg?v=1769483339",
      "alt": "Compact daypack perfect for hiking, biking, and city travel."
    },
    {
      "id": "28746484777150",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Falcon-Water-Repellent-Hiking-Camping-Backpack-Compact-Pack-Summit-Bag-Seibertron-28746484777150.jpg?v=1769483335",
      "alt": "Foldable and portable camping gear backpack for hassle-free adventures."
    },
    {
      "id": "28746483794110",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Falcon-Water-Repellent-Hiking-Camping-Backpack-Compact-Pack-Summit-Bag-Seibertron-28746483794110.jpg?v=1769483335",
      "alt": "Water-resistant backpack designed for summit climbs and exploration."
    },
    {
      "id": "28746484449470",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Falcon-Water-Repellent-Hiking-Camping-Backpack-Compact-Pack-Summit-Bag-Seibertron-28746484449470.jpg?v=1769483335",
      "alt": "Large capacity hiking backpack perfect for multi-day outdoor trips."
    },
    {
      "id": "24008373305534",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/products/Seibertron-Falcon-Water-Repellent-Hiking-Camping-Backpack-Compact-Pack-Summit-Bag-Seibertron-24008373305534.jpg?v=1769483335",
      "alt": "Seibertron Falcon backpack ideal for outdoor adventure and exploration."
    },
    {
      "id": "28746484482238",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Falcon-Water-Repellent-Hiking-Camping-Backpack-Compact-Pack-Summit-Bag-Seibertron-28746484482238.jpg?v=1769483335",
      "alt": "Versatile hiking and camping backpack suitable for both men and women."
    },
    {
      "id": "28746484809918",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Falcon-Water-Repellent-Hiking-Camping-Backpack-Compact-Pack-Summit-Bag-Seibertron-28746484809918.jpg?v=1769483335",
      "alt": "Waterproof camping bag for keeping your gear dry and protected."
    },
    {
      "id": "28746483695806",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Falcon-Water-Repellent-Hiking-Camping-Backpack-Compact-Pack-Summit-Bag-Seibertron-28746483695806.jpg?v=1769483335",
      "alt": "Comfortable trekking backpack with ergonomic shoulder straps."
    },
    {
      "id": "28746484220094",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Falcon-Water-Repellent-Hiking-Camping-Backpack-Compact-Pack-Summit-Bag-Seibertron-28746484220094.jpg?v=1769483335",
      "alt": "Reliable hiking gear backpack for all outdoor activities."
    },
    {
      "id": "28746484351166",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Falcon-Water-Repellent-Hiking-Camping-Backpack-Compact-Pack-Summit-Bag-Seibertron-28746484351166.jpg?v=1769483335",
      "alt": "Foldable travel backpack designed for compact storage."
    },
    {
      "id": "24008373239998",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/products/Seibertron-Falcon-Water-Repellent-Hiking-Camping-Backpack-Compact-Pack-Summit-Bag-Seibertron-24008373239998.jpg?v=1769483335",
      "alt": "Lightweight backpack made with water-repellent materials for outdoor use."
    },
    {
      "id": "28746484056254",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Falcon-Water-Repellent-Hiking-Camping-Backpack-Compact-Pack-Summit-Bag-Seibertron-28746484056254.jpg?v=1769483335",
      "alt": "Men's adventure backpack perfect for hiking, camping, and trekking."
    },
    {
      "id": "24008373371070",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/products/Seibertron-Falcon-Water-Repellent-Hiking-Camping-Backpack-Compact-Pack-Summit-Bag-Seibertron-24008373371070.jpg?v=1769483335",
      "alt": "Compact backpack designed for weekend getaways and day trips."
    },
    {
      "id": "28746483499198",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Falcon-Water-Repellent-Hiking-Camping-Backpack-Compact-Pack-Summit-Bag-Seibertron-28746483499198.jpg?v=1769483335",
      "alt": "Backpack with durable zippers ensuring secure storage for hiking gear.\n"
    },
    {
      "id": "24008378679486",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/products/Seibertron-Falcon-Water-Repellent-Hiking-Camping-Backpack-Compact-Pack-Summit-Bag-Seibertron-24008378679486.jpg?v=1769483335",
      "alt": "Water-resistant travel backpack suitable for outdoor enthusiasts."
    },
    {
      "id": "24008373141694",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/products/Seibertron-Falcon-Water-Repellent-Hiking-Camping-Backpack-Compact-Pack-Summit-Bag-Seibertron-24008373141694.jpg?v=1769483335",
      "alt": "Lightweight hiking bag designed for comfort during long treks."
    },
    {
      "id": "28746483237054",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Falcon-Water-Repellent-Hiking-Camping-Backpack-Compact-Pack-Summit-Bag-Seibertron-28746483237054.jpg?v=1769483344",
      "alt": "Hiking backpack with breathable straps for enhanced ventilation."
    },
    {
      "id": "24117281652926",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/products/Waterproof-Adventure-Backpack-Camping-Gear..jpg?v=1763361622",
      "alt": "Waterproof adventure backpack designed for rugged camping gear."
    },
    {
      "id": "28746483204286",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Falcon-Backpack-Lightweight-Durable-Design..jpg?v=1763361622",
      "alt": "Lightweight and durable backpack ideal for daily hiking."
    },
    {
      "id": "28746483400894",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Foldable-Daypack-For-Light-Travel..jpg?v=1763361622",
      "alt": "Compact daypack perfect for light travel and spontaneous adventures."
    },
    {
      "id": "24008373076158",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/products/Seibertron-Outdoor-Backpack-For-Camping..jpg?v=1763361622",
      "alt": "Outdoor backpack designed for efficient camping gear storage."
    },
    {
      "id": "28746483138750",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Hiking-Backpack-With-Ergonomic-Back-Panel..jpg?v=1763361622",
      "alt": "Ergonomic back panel hiking backpack for ultimate comfort."
    },
    {
      "id": "24009011396798",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/products/Waterproof-Backpack-For-Heavy-Rain..jpg?v=1763361622",
      "alt": "Heavy rain waterproof backpack for extreme outdoor conditions."
    },
    {
      "id": "24127619858622",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/products/Seibertron-Falcon-Adventure-Gear-Bag..jpg?v=1763361622",
      "alt": "Adventure gear bag designed for durability and water resistance."
    },
    {
      "id": "24127847006398",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/products/luggage_strap_black-Lightweight-Summit-Backpack-Compact-Design..jpg?v=1763361622",
      "alt": "Lightweight summit backpack with a compact and foldable design."
    },
    {
      "id": "24127847432382",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/products/luggage_strap_khaki.jpg?v=1763361622",
      "alt": "Expandable storage backpack perfect for multi-day hiking trips."
    },
    {
      "id": "28746483269822",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Water-Resistant-Backpack-Outdoor..jpg?v=1763361622",
      "alt": "Water-resistant outdoor backpack for hiking, camping, and trekking."
    },
    {
      "id": "28746483105982",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Hiking-Backpack-With-Side-Pockets..jpg?v=1763361622",
      "alt": "Hiking backpack with side pockets for convenient access to essentials."
    },
    {
      "id": "28746483466430",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Backpack-Comfortable-Back-Support..jpg?v=1763361622",
      "alt": "Backpack with comfortable back support for extended hiking trips."
    },
    {
      "id": "28746483859646",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Trekking-Backpack-For-Men-Women..jpg?v=1763361622",
      "alt": "Unisex trekking backpack designed for durability and style."
    },
    {
      "id": "28746484744382",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Waterproof-Backpack-With-Secure-Closures..jpg?v=1763361622",
      "alt": "Waterproof backpack with secure closures for safe gear storage."
    },
    {
      "id": "28746484089022",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Lightweight-Camping-Backpack-With-Padded-Straps..jpg?v=1763361622",
      "alt": "Camping backpack with padded straps for enhanced comfort."
    },
    {
      "id": "28746484187326",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Foldable-Hiking-Bag-For-Outdoor-Adventures..jpg?v=1763361622",
      "alt": "Foldable hiking bag perfect for spontaneous outdoor adventures."
    },
    {
      "id": "28746483761342",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Adventure-Backpack-With-Multi-Compartment..jpg?v=1763361622",
      "alt": "Adventure backpack with multiple compartments for organized packing."
    },
    {
      "id": "28746483040446",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Outdoor-Backpack-Waterproof-Design..jpg?v=1768015982",
      "alt": "Waterproof design outdoor backpack built for extreme conditions."
    },
    {
      "id": "28746484973758",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Summit-Backpack-Lightweight-Durable..jpg?v=1763361622",
      "alt": "Lightweight and durable summit backpack for alpine adventures."
    },
    {
      "id": "28746484908222",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Hiking-Backpack-With-Quick-Access-Pockets..jpg?v=1763361622",
      "alt": "Hiking backpack with quick-access pockets for essentials."
    },
    {
      "id": "28746485006526",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Falcon-Backpack-For-Extreme-Weather..jpg?v=1763361622",
      "alt": "Backpack designed to withstand extreme weather conditions during hikes."
    },
    {
      "id": "28746484023486",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Compact-Backpack-With-Water-Repellent-Finish..jpg?v=1763361622",
      "alt": "Compact backpack featuring a water-repellent finish for outdoor travel."
    },
    {
      "id": "28746484285630",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Falcon-Backpack-Rugged-Outdoor-Design..jpg?v=1763361622",
      "alt": "Rugged outdoor backpack designed for challenging hiking trails and camping trips."
    },
    {
      "id": "28746484416702",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Waterproof-Hiking-Backpack-For-Wet-Conditions..jpg?v=1763361622",
      "alt": "Waterproof hiking backpack ideal for wet and rainy outdoor conditions."
    },
    {
      "id": "28746484121790",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Lightweight-Camping-Backpack-With-Large-Capacity..jpg?v=1763361622",
      "alt": "Lightweight camping backpack offering large capacity for essential gear."
    },
    {
      "id": "28746483990718",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Falcon-Compact-Backpack-For-Travel..jpg?v=1763361622",
      "alt": "Compact travel backpack designed for efficient storage during outdoor trips."
    },
    {
      "id": "28746483531966",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Adventure-Backpack-With-Durable-Fabric..jpg?v=1763361622",
      "alt": "Adventure backpack crafted with durable, tear-resistant fabric for long-lasting use."
    },
    {
      "id": "28746483335358",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Foldable-Outdoor-Backpack-Light-and-Convenient..jpg?v=1763361622",
      "alt": "Lightweight and convenient foldable outdoor backpack for spontaneous adventures."
    },
    {
      "id": "28746484252862",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Falcon-Outdoor-Pack-For-Camping..jpg?v=1763361622",
      "alt": "Outdoor pack designed for efficient camping storage and easy transport."
    },
    {
      "id": "28746484318398",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Compact-Foldable-Backpack-Easy-to-Store..jpg?v=1763361622",
      "alt": "Compact and foldable backpack that’s easy to store and carry for any trip."
    },
    {
      "id": "28746484875454",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Hiking-Daypack-With-Lightweight-Construction..jpg?v=1763361622",
      "alt": "Lightweight hiking daypack designed for comfort and easy portability."
    },
    {
      "id": "28746484547774",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Waterproof-Backpack-With-Secure-Zipper-Closure..jpg?v=1763361622",
      "alt": "Waterproof backpack featuring secure zipper closures for maximum protection."
    },
    {
      "id": "28746484383934",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Adventure-Backpack-With-Side-Pockets..jpg?v=1763361622",
      "alt": "Adventure backpack with convenient side pockets for easy gear access."
    },
    {
      "id": "28746482974910",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Lightweight-Backpack-Perfect-For-Camping-Trips..jpg?v=1768015992",
      "alt": "Lightweight and compact backpack perfect for camping and weekend hikes."
    },
    {
      "id": "28746483957950",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Outdoor-Hiking-Backpack-With-Ergonomic-Design..jpg?v=1763361622",
      "alt": "Outdoor hiking backpack featuring ergonomic design for back support."
    },
    {
      "id": "24008373174462",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/products/Outdoor_hiking_backpack_featuring_ergonomic_design_for_back_support..jpg?v=1763361622",
      "alt": "Travel backpack with water-repellent features, perfect for avid hikers."
    },
    {
      "id": "28746484646078",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Falcon-Lightweight-Camping-Gear-Bag..jpg?v=1763361622",
      "alt": "Lightweight camping gear bag designed for easy organization and transport."
    },
    {
      "id": "28746483892414",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Adventure-Backpack-With-Breathable-Padding..jpg?v=1763361622",
      "alt": "Adventure backpack featuring breathable padding for all-day hiking comfort."
    },
    {
      "id": "28746484842686",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Waterproof-Summit-Backpack-For-Climbers..jpg?v=1763361622",
      "alt": "Waterproof summit backpack built for climbers and outdoor adventurers."
    },
    {
      "id": "28746484940990",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Falcon-Hiking-Backpack-With-Reflective-Strips..jpg?v=1763361622",
      "alt": "Hiking backpack with reflective strips for enhanced visibility during night treks."
    },
    {
      "id": "28746484515006",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Waterproof-Camping-Backpack-With-Heavy-Duty-Straps..jpg?v=1763361622",
      "alt": "Waterproof camping backpack equipped with heavy-duty straps for secure carrying."
    },
    {
      "id": "33519253586110",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-falcon-black-37l-plus-1-detachable-pack-thumbnail-20260724.png?v=1784879500",
      "alt": "seibertron-gallery:falcon-black-1-detachable-thumbnail-20260724 | product:falcon-backpack | color:Black 37L+1detachable Pack | white-background main thumbnail"
    }
  ],
  "variants": [
    {
      "id": "41897659039934",
      "title": "Khaki 37L (size:11\"*11\"*19\")",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Khaki 37L (size:11\"*11\"*19\")"
        }
      ],
      "values": [
        "Khaki 37L (size:11\"*11\"*19\")"
      ],
      "mediaId": "33449078554814"
    },
    {
      "id": "41897658941630",
      "title": "Black 37L (size:11\"*11\"*19\")",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black 37L (size:11\"*11\"*19\")"
        }
      ],
      "values": [
        "Black 37L (size:11\"*11\"*19\")"
      ],
      "mediaId": "33449078587582"
    },
    {
      "id": "41897658908862",
      "title": "Black 37L+1detachable Pack",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black 37L+1detachable Pack"
        }
      ],
      "values": [
        "Black 37L+1detachable Pack"
      ],
      "mediaId": "33519253586110"
    },
    {
      "id": "41897659007166",
      "title": "Khaki 37L+1detachable Pack",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Khaki 37L+1detachable Pack"
        }
      ],
      "values": [
        "Khaki 37L+1detachable Pack"
      ],
      "mediaId": "33449078554814"
    },
    {
      "id": "41897658974398",
      "title": "Black 37L+ 2 Detachable Packs",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black 37L+ 2 Detachable Packs"
        }
      ],
      "values": [
        "Black 37L+ 2 Detachable Packs"
      ],
      "mediaId": "33449078587582"
    },
    {
      "id": "41897659072702",
      "title": "Khaki 37L+ 2 Detachable Packs",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Khaki 37L+ 2 Detachable Packs"
        }
      ],
      "values": [
        "Khaki 37L+ 2 Detachable Packs"
      ],
      "mediaId": "33449078554814"
    },
    {
      "id": "41897659105470",
      "title": "Black 27L (size:9\"*11\"*16.5\")",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black 27L (size:9\"*11\"*16.5\")"
        }
      ],
      "values": [
        "Black 27L (size:9\"*11\"*16.5\")"
      ],
      "mediaId": "24008373272766"
    },
    {
      "id": "41897659138238",
      "title": "Khaki 27L (size:9\"*11\"*16.5\")",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Khaki 27L (size:9\"*11\"*16.5\")"
        }
      ],
      "values": [
        "Khaki 27L (size:9\"*11\"*16.5\")"
      ],
      "mediaId": "24008373305534"
    },
    {
      "id": "41897663398078",
      "title": "Pouch Khaki",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Pouch Khaki"
        }
      ],
      "values": [
        "Pouch Khaki"
      ],
      "mediaId": "24008378679486"
    },
    {
      "id": "41897899688126",
      "title": "Pouch Black",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Pouch Black"
        }
      ],
      "values": [
        "Pouch Black"
      ],
      "mediaId": "24009011396798"
    },
    {
      "id": "41970397184190",
      "title": "2L Water Bladder",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "2L Water Bladder"
        }
      ],
      "values": [
        "2L Water Bladder"
      ],
      "mediaId": "24127619858622"
    },
    {
      "id": "41970555519166",
      "title": "2 pieces of sissy bar straps black",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "2 pieces of sissy bar straps black"
        }
      ],
      "values": [
        "2 pieces of sissy bar straps black"
      ],
      "mediaId": "24127847006398"
    },
    {
      "id": "41970555551934",
      "title": "2 pieces of sissy bar straps khaki",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "2 pieces of sissy bar straps khaki"
        }
      ],
      "values": [
        "2 pieces of sissy bar straps khaki"
      ],
      "mediaId": "24127847432382"
    }
  ],
  "singleVariant": false,
  "colorSwatches": {
    "Khaki 37L (size:11\"*11\"*19\")": "24008373207230",
    "Black 37L (size:11\"*11\"*19\")": "24117278113982",
    "Black 37L+1detachable Pack": "33519253586110",
    "Khaki 37L+1detachable Pack": "28746482974910",
    "Black 37L+ 2 Detachable Packs": "24008373141694",
    "Khaki 37L+ 2 Detachable Packs": "24008373239998",
    "Black 27L (size:9\"*11\"*16.5\")": "24008373272766",
    "Khaki 27L (size:9\"*11\"*16.5\")": "24008373305534",
    "Pouch Khaki": "24008378679486",
    "Pouch Black": "24009011396798",
    "2L Water Bladder": "24127619858622",
    "2 pieces of sissy bar straps black": "24127847006398",
    "2 pieces of sissy bar straps khaki": "24127847432382"
  },
  "optimizeColorSwatches": false,
  "forceExactColorSwatches": true
};
  var applying = false;
  function root() {
    return document.querySelector('.auto-product[data-product-handle="' + config.handle + '"]');
  }
  function absolute(url) {
    if (!url) return '';
    if (url.indexOf('//') === 0) return window.location.protocol + url;
    if (url.charAt(0) === '/') return window.location.origin + url;
    return url;
  }
  function sized(url, width) {
    try {
      var parsed = new URL(absolute(url), window.location.origin);
      parsed.searchParams.set('width', String(width));
      return parsed.href;
    } catch (error) {
      return absolute(url);
    }
  }
  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function selectedValues(scope) {
    return Array.prototype.slice.call(scope.querySelectorAll('input[name^="options["]:checked')).map(function (input) {
      return input.value || '';
    });
  }
  function selectedEntry(scope) {
    var selectedColor = scope.querySelector('input[name="options[Color]"]:checked');
    var exactColorMediaId = selectedColor && config.colorSwatches ? config.colorSwatches[selectedColor.value] : '';
    if (exactColorMediaId) {
      var exactColorEntry = config.entries.find(function (entry) { return entry.id === exactColorMediaId; });
      if (exactColorEntry) return exactColorEntry;
    }
    var values = selectedValues(scope);
    var variant = config.variants.find(function (item) {
      return item.values.length === values.length && item.values.every(function (value, index) { return value === values[index]; });
    });
    return variant ? config.entries.find(function (entry) { return entry.id === variant.mediaId; }) : null;
  }
  function selectedVariant(scope) {
    var values = selectedValues(scope);
    return config.variants.find(function (item) {
      return item.values.length === values.length && item.values.every(function (value, index) { return value === values[index]; });
    }) || null;
  }
  function syncPurchase(scope) {
    var variant = selectedVariant(scope);
    if (!variant) return;
    scope.querySelectorAll('form[action*="/cart/add"] [name="id"]').forEach(function (field) {
      if (String(field.value || '') !== String(variant.id)) {
        field.value = variant.id;
        field.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    scope.querySelectorAll('form[action*="/cart/add"] button[type="submit"]').forEach(function (button) {
      button.disabled = !variant.availableForSale;
      button.setAttribute('aria-disabled', variant.availableForSale ? 'false' : 'true');
      var label = button.querySelector('span') || button;
      if (variant.availableForSale && /solds*out|unavailable/i.test(label.textContent || '')) label.textContent = 'Add to Cart';
      if (!variant.availableForSale && /adds*tos*cart/i.test(label.textContent || '')) label.textContent = 'Sold Out';
    });
  }
  function syncApprovedDescriptionCopy(scope) {
    if (config.handle !== 'seibertron-motorbike-backpack-motorcycle-bag-outdoor-sports-riding-package') return;
    var oldOpening = 'Ultimate Water-Resistant Backpack: Built with durable 900D waterproof fabric, this backpack is designed for riders and outdoor users who need dependable everyday protection from light rain and road spray.';
    var oldNote = 'Water-Resistance Note: The 900D fabric is waterproof, but the complete backpack is water resistant rather than fully waterproof because zippers and stitch openings can allow moisture through. Always close the backpack securely to help keep gear dry.';
    var oldHighlight = '900D waterproof fabric and water-resistant backpack construction help protect gear in everyday conditions.';
    Array.prototype.slice.call(scope.querySelectorAll('p')).forEach(function (paragraph) {
      var text = String(paragraph.textContent || '').replace(/\s+/g, ' ').trim();
      if (text === oldOpening) {
        paragraph.innerHTML = '<strong>Introducing the Ultimate Water Resistant Backpack!</strong> Made from durable 900D water resistant material, this backpack is perfect for outdoor enthusiasts who need reliable protection from the elements ...';
      } else if (text === oldNote) {
        paragraph.innerHTML = '<strong>Water Resistance Note:</strong> The backpack uses water resistant 900D material and construction for everyday protection. Moisture can still pass through zippers and stitch openings, so it is not designed for submersion. Always close the backpack securely to help keep gear dry.';
      }
    });
    Array.prototype.slice.call(scope.querySelectorAll('li')).forEach(function (item) {
      var text = String(item.textContent || '').replace(/\s+/g, ' ').trim();
      if (text === oldHighlight) item.textContent = 'Durable 900D water resistant material and backpack construction help protect gear in everyday conditions.';
    });
  }
  function setMain(scope, entry) {
    var main = scope.querySelector('[data-auto-main-image]');
    if (!main || !entry) return;
    main.src = sized(entry.src, 1200);
    main.srcset = '';
    main.alt = entry.alt || main.alt || '';
  }
  function syncVisualChoices(scope) {
    scope.querySelectorAll('.auto-product__choice--visual').forEach(function (choice) {
      var input = choice.querySelector('input[name^="options["]');
      if (!input) return;
      var optionMatch = String(input.name || '').match(/^options\[(.+)\]$/);
      if (!optionMatch) return;
      var optionName = optionMatch[1];
      var exactColorMediaId = optionName === 'Color' && config.colorSwatches ? config.colorSwatches[input.value] : '';
      var mediaIds = exactColorMediaId ? [exactColorMediaId] : config.variants.filter(function (variant) {
        return (variant.options || []).some(function (option) {
          return option.name === optionName && option.value === input.value;
        });
      }).map(function (variant) { return variant.mediaId; }).filter(Boolean).filter(function (id, index, all) {
        return all.indexOf(id) === index;
      });
      if (mediaIds.length !== 1) return;
      var entry = config.entries.find(function (item) { return item.id === mediaIds[0]; });
      if (!entry) return;
      if (config.forceExactColorSwatches && optionName === 'Color') {
        var shell = choice.querySelector('[data-auto-choice-label]') || choice;
        var expectedSrc = sized(entry.src, 180);
        var existingImage = shell.querySelector('img');
        if (!(existingImage && existingImage.src === expectedSrc && existingImage.alt === input.value)) {
          shell.innerHTML = '<span class="auto-product__swatch-image" aria-label="' + escapeHtml(input.value || entry.alt || '') + '"><img src="' + escapeHtml(expectedSrc) + '" alt="' + escapeHtml(input.value || entry.alt || '') + '" width="72" height="72" loading="eager"></span><span class="auto-product__swatch-label">' + escapeHtml(input.value || '') + '</span>';
        }
        choice.setAttribute('data-variant-media-id', entry.id);
        choice.setAttribute('data-falcon-full-gallery-swatch-media-id', entry.id);
        return;
      }
      var swatch = choice.querySelector('.auto-product__swatch-image');
      if (!swatch) {
        swatch = document.createElement('span');
        swatch.className = 'auto-product__swatch-image';
        swatch.setAttribute('aria-label', input.value || entry.alt || '');
        (choice.querySelector('[data-auto-choice-label]') || choice).appendChild(swatch);
      }
      var image = swatch.querySelector('img');
      if (!image) {
        image = document.createElement('img');
        image.width = 72;
        image.height = 72;
        image.loading = 'lazy';
        swatch.appendChild(image);
      }
      image.src = sized(entry.src, 180);
      image.srcset = '';
      image.alt = input.value || entry.alt || '';
      choice.setAttribute('data-variant-media-id', entry.id);
    });
  }
  function ensureScopedStyles(scope) {
    if (!config.optimizeColorSwatches || document.getElementById('sps5-gallery-swatch-layout-20260716')) return;
    var style = document.createElement('style');
    style.id = 'sps5-gallery-swatch-layout-20260716';
    style.textContent = [
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__thumbs{display:flex!important;visibility:visible!important;opacity:1!important;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__thumb{display:grid!important;visibility:visible!important;opacity:1!important;flex:0 0 auto;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__choices{display:grid!important;grid-template-columns:repeat(6,minmax(58px,1fr));gap:10px;width:100%;overflow:visible;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__choice--visual{width:100%;min-width:0;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__choice--visual>[data-auto-choice-label]{width:100%!important;min-width:0!important;height:auto!important;min-height:0!important;aspect-ratio:1/1;display:flex!important;align-items:center!important;justify-content:center!important;overflow:hidden!important;background:#fff!important;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__swatch-image,.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__swatch-image img{width:100%!important;height:100%!important;display:block!important;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__swatch-image img{object-fit:contain!important;object-position:center!important;background:#fff!important;padding:3px!important;box-sizing:border-box!important;}',
      '@media(max-width:640px){.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__choices{grid-template-columns:repeat(3,minmax(64px,1fr));gap:10px;}}'
    ].join('');
    document.head.appendChild(style);
  }
  function syncSingleVariantLegend(scope) {
    if (!config.singleVariant) return;
    scope.querySelectorAll('.auto-product__option legend').forEach(function (legend) {
      legend.style.setProperty('justify-content', 'flex-start', 'important');
      legend.style.setProperty('align-items', 'center', 'important');
      legend.style.setProperty('gap', '16px', 'important');
      legend.style.setProperty('width', 'fit-content', 'important');
      legend.style.setProperty('max-width', '100%', 'important');
    });
  }
  function ensureThumb(scope, wrap, entry, index) {
    var thumb = wrap.querySelector('[data-auto-thumb][data-media-id="' + entry.id + '"]');
    if (!thumb) {
      thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.className = 'auto-product__thumb';
      thumb.setAttribute('data-auto-thumb', '');
      wrap.appendChild(thumb);
    }
    thumb.setAttribute('data-media-id', entry.id);
    thumb.setAttribute('data-safe-gallery-media', 'true');
    thumb.setAttribute('data-src', sized(entry.src, 1200));
    thumb.setAttribute('data-alt', entry.alt || '');
    thumb.setAttribute('aria-label', 'View image ' + (index + 1));
    thumb.setAttribute('aria-hidden', 'false');
    thumb.hidden = false;
    thumb.style.display = '';
    if (!thumb.querySelector('img')) {
      thumb.innerHTML = '<img src="' + escapeHtml(sized(entry.src, 160)) + '" alt="' + escapeHtml(entry.alt || '') + '" width="76" height="76" loading="lazy">';
    }
    if (thumb.dataset.motorbikeGalleryBound !== 'true') {
      thumb.dataset.motorbikeGalleryBound = 'true';
      thumb.addEventListener('click', function () {
        setMain(scope, entry);
        scope.querySelectorAll('[data-auto-thumb]').forEach(function (node) {
          node.classList.toggle('is-active', node === thumb);
        });
      });
    }
    return thumb;
  }
  function hydrate() {
    if (applying) return;
    var scope = root();
    if (!scope) return;
    var wrap = scope.querySelector('.auto-product__thumbs');
    if (!wrap) return;
    applying = true;
    var desiredSafeIds = '|' + config.entries.map(function (entry) { return entry.id; }).join('|') + '|';
    if (scope.getAttribute('data-safe-gallery-media-ids') !== desiredSafeIds) {
      scope.setAttribute('data-safe-gallery-media-ids', desiredSafeIds);
    }
    ensureScopedStyles(scope);
    config.entries.forEach(function (entry, index) { ensureThumb(scope, wrap, entry, index); });
    scope.querySelectorAll('[data-auto-thumb]').forEach(function (thumb) {
      var isDesired = config.entries.some(function (entry) { return entry.id === thumb.getAttribute('data-media-id'); });
      thumb.hidden = !isDesired;
      thumb.style.display = isDesired ? '' : 'none';
      thumb.setAttribute('aria-hidden', isDesired ? 'false' : 'true');
    });
    syncVisualChoices(scope);
    syncSingleVariantLegend(scope);
    syncApprovedDescriptionCopy(scope);
    syncPurchase(scope);
    setMain(scope, selectedEntry(scope));
    applying = false;
  }
  function run() {
    var scope = root();
    if (!scope) return;
    hydrate();
    if (scope.dataset.motorbikeBackpackGalleryRestoreBound === 'true') return;
    scope.dataset.motorbikeBackpackGalleryRestoreBound = 'true';
    scope.addEventListener('change', function (event) {
      if (!event.target || !event.target.matches('input[name^="options["]')) return;
      [0, 80, 250, 700, 1400].forEach(function (delay) {
        window.setTimeout(function () {
          hydrate();
          setMain(scope, selectedEntry(scope));
          syncPurchase(scope);
        }, delay);
      });
    });
    var observer = new MutationObserver(function (records) {
      if (applying) return;
      var changed = records.some(function (record) {
        return record.type === 'attributes' || record.addedNodes.length || record.removedNodes.length;
      });
      if (changed) window.setTimeout(hydrate, 0);
    });
    observer.observe(scope, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-safe-gallery-media-ids', 'src', 'srcset', 'data-variant-media-id']
    });
  }
  run();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  [150, 500, 1300, 3000, 6000, 10000].forEach(function (delay) { window.setTimeout(hydrate, delay); });
  window.setInterval(hydrate, 1200);
})();
// END motorbikeBackpackGalleryRestore20260716
